import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { registerSW } from 'virtual:pwa-register'

// 函数式组件与指令的样式需手动引入
// （模板组件的样式由 unplugin-vue-components 按需自动注入）
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/message-box/style/css'
import 'element-plus/es/components/loading/style/css'

import App from './App.vue'
import router from './router'
import './styles/theme.css'
import './styles/mobile.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.mount('#app')

// 注册 PWA Service Worker，并提供丝滑的应用内更新提示
const updateSW = registerSW({
  onNeedRefresh() {
    // 接近 APP 的更新体验：顶部轻提示，点击立即刷新
    const tip = document.createElement('div')
    tip.className = 'pwa-update-toast'
    tip.innerHTML = '<span>有新版本可用</span><button>刷新</button>'
    tip.querySelector('button')?.addEventListener('click', () => updateSW(true))
    document.body.appendChild(tip)
    requestAnimationFrame(() => tip.classList.add('show'))
  },
  onOfflineReady() {
    console.info('[PWA] 已就绪，可离线使用')
  }
})
